import { render } from "./SettingsInternalPlugin.vue?vue&type=template&id=41494a80&scoped=true"
import script from "./SettingsInternalPlugin.vue?vue&type=script&lang=js"
export * from "./SettingsInternalPlugin.vue?vue&type=script&lang=js"

import "./SettingsInternalPlugin.vue?vue&type=style&index=0&id=41494a80&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41494a80"]])

export default __exports__